import { combineReducers } from 'redux';
import accountReducer from './auth/reducer';
import usersReducer from './users/reducer';
import empresaReducer from './empresa/reducer';
import paineisUsers from './paineisUsers/reducer';
import metasReducer from './metas/reducer';
import gruposControleReducer from './gruposControle/reducer';
import fatorReducer from './fator/reducer';
import campanhaReducer from './campanha/reducer';
import estoqueReducer from './estoque/reducer';
import curvaReducer from './curva/reducer';
import categoriasReducer from './categorias/reducer';
import colaboradoresReducer from './colaboradores/reducer';
import parametrosIntegracaoReducer from './parametrosBi/parametrosIntegracao/reducer';
import parametrosEmbeddedBiReducer from './parametrosBi/parametrosEmbeddedBi/reducer';
import painel from './paineis/reducer';
import classificacoes from './classificacoes/reducer';
import motivos from './motivosStatusEmpresa/reducer';
import parametrosLocais from './parametrosLocais/reducer';
import parametrosGlobais from './parametrosGlobais/reducer';
import dadosExternos from './dadosExternos/reducer';
import construtorRelatorios from './construtorRelatorios/reducer';
import cloudFlare from './cloudFlare/reducer';
import machines from './pgloader/machines/reducer';
import shedules from './pgloader/shedules/reducer';
import logs from './pgloader/logs/reducer';
import definicoesPbi from './definicoesPbi/reducer';
import chatIA from './chatIA/reducer';
import erpsReducer from './erps/reducer';
import querysReducer from './querys/reducer';
import variaveisGlobaisReducer from './parametrosBi/variaveisGlobais/reducer';
import variaveisReducer from './variaveis/reducer';
import sourcesGlobaisReducer from './sourcesGlobais/reducer';
import validacaoRelatoriosIqviaReducer from './validacaoRelatoriosIqvia/reducer';
import infoFinanceiras from './infoFinanceiras/reducer';

const reducers = combineReducers({
  account: accountReducer,
  users: usersReducer,
  empresa: empresaReducer,
  paineisUsers: paineisUsers,
  metas: metasReducer,
  gruposControle: gruposControleReducer,
  fator: fatorReducer,
  campanha: campanhaReducer,
  estoque: estoqueReducer,
  curva: curvaReducer,
  categorias: categoriasReducer,
  colaboradores: colaboradoresReducer,
  parametrosIntegracaoReducer: parametrosIntegracaoReducer,
  parametrosEmbeddedBiReducer: parametrosEmbeddedBiReducer,
  painel: painel,
  classificacoes: classificacoes,
  motivos: motivos,
  parametrosGlobais: parametrosGlobais,
  parametrosLocais: parametrosLocais,
  dadosExternos: dadosExternos,
  cloudFlare: cloudFlare,
  construtorRelatorios: construtorRelatorios,
  machines: machines,
  shedules: shedules,
  logs: logs,
  chatIA: chatIA,
  erps: erpsReducer,
  querys: querysReducer,
  variaveisGlobais: variaveisGlobaisReducer,
  variaveis: variaveisReducer,
  sourcesGlobais: sourcesGlobaisReducer,
  definicoesPbi: definicoesPbi,
  validacaoRelatoriosIqvia: validacaoRelatoriosIqviaReducer,
  infoFinanceiras: infoFinanceiras
});

export default reducers;
